import { OAuth2CallbackPage } from '@arivaa-react/components/socialSignIn';

export default OAuth2CallbackPage;

OAuth2CallbackPage.routeProps = {
  header: false,
};
